import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {FaSolidIcon} from "../../../../components/FontAwesomeIcons";
import Page from "../../../../components/BaseComponents/Page/Page";
import {DisputeListViewItem} from "./DisputeListViewItem";
import ModalPortalHOC from "../../../../components/BaseComponents/ModalPortalHOC";
import {BusinessWithUserDisputePanel} from "./BusinessWithUserDisputePanel";
import {UserAdminChatAPI} from "../../../../api/Chat/UserAdminChatAPI";
import FuxEvents from "../../../../lib/FuxFramework/FuxEvents";
import {ADMIN_DISPUTE_CHAT_READ_EVT} from "../../../../const/AppEventsCostants";

export class DisputeListPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            disputeOpen: null,
        }
    }

    componentDidMount() {
        FuxEvents.on(ADMIN_DISPUTE_CHAT_READ_EVT, this.silentUpdate)
    }

    componentWillUnmount() {
        FuxEvents.off(ADMIN_DISPUTE_CHAT_READ_EVT, this.silentUpdate)
    }

    handleDisputeOpen = dispute => {
        this.setState({disputeOpen: dispute});
        //imposto come letti i messaggi della chat aperta
        UserAdminChatAPI.setRead(dispute.id_chat_room)
            .then(_ => FuxEvents.emit(ADMIN_DISPUTE_CHAT_READ_EVT));
    }

    handleDisputeClose = silent => {
        this.setState({disputeOpen: null});
    }

    silentUpdate = _ => this.props.onUpdate(true);
    visibleUpdate = _ => this.props.onUpdate(false);
    render() {
        return (
            <Fragment>
                <Page
                    active={true}
                    title={"Richieste di rimborso"}
                    leftIcon={<FaSolidIcon name={"chevron-left"}/>}
                    onLeftIconClick={this.props.onDismiss}
                    rightIcon={<FaSolidIcon name={"sync"}/>}
                    rightIconText={"Aggiorna"}
                    onRightIconClick={this.visibleUpdate}
                >
                    <div className={"container mt-3"}>
                        {
                            this.props.disputes.map((d, i) =>
                                <DisputeListViewItem
                                    className={i === 0 ? 'border-top-0' : ''}
                                    key={d.id_chat_room}
                                    onClick={this.handleDisputeOpen}
                                    disputeData={d}
                                    newMessageNumber={parseInt(d.nuovi_messaggi)}
                                />
                            )
                        }
                    </div>
                </Page>
                <ModalPortalHOC>
                    {
                        this.state.disputeOpen &&
                        <BusinessWithUserDisputePanel
                            disputeData={this.state.disputeOpen}
                            onClose={this.handleDisputeClose}
                        />
                    }
                </ModalPortalHOC>
            </Fragment>
        )
    }

}

DisputeListPage.propTypes = {
    disputes: PropTypes.array,
    onDismiss: PropTypes.func,
    onUpdate: PropTypes.func,
}